module.exports={
  "climate": {
    "climate-issue-1": {
      "climate-issue-1-answer-1": "Expand rebate programs, e.g. to replace lawns with drought-tolerant landscaping and to purchase water-efficient appliances for homes and businesses",
      "climate-issue-1-answer-2": "Make outdoor watering rules even more strict and increase enforcement of rules at both homes and businesses",
      "climate-issue-1-answer-3": "Ban non-drought-tolerant grass in new developments and commercial and industrial settings",
      "climate-issue-1-answer-4": "Speed up water recycling and stormwater capture efforts"
    },
    "climate-issue-2": {
      "climate-issue-2-answer-1": "Provide more direct support to Angelenos during extreme heat waves: e.g. open more cooling stations, provide more subsidized air conditioning and assistance on utility bills, etc.",
      "climate-issue-2-answer-2": "Improve cooling infrastructure in neighborhoods with less tree cover: e.g. plant trees, build shade structures, expand green space, etc.",
      "climate-issue-2-answer-3": "Mandate indoor cooling standards for homes and workplaces so developers and landlords are required to incorporate heat resilience",
      "climate-issue-2-answer-4": "Increase public messaging around the dangers of extreme heat and how to keep yourself and loved ones safe"
    },
    "climate-issue-3": {
      "climate-issue-3-answer-1": "Expand public transit and bike and pedestrian-friendly areas ",
      "climate-issue-3-answer-2": "Expand rebate programs and provide other incentives to get more people into electric or hybrid vehicles or using public transportation",
      "climate-issue-3-answer-3": "Expand the city’s electric vehicle charging network",
      "climate-issue-3-answer-4": "Double down on investments in hydrogen fuel technology",
      "climate-issue-3-answer-5": "Implement gas engine vehicle restrictions"
    },
    "climate-issue-4": {
      "climate-issue-4-answer-1": "Increase resources for fighting fires",
      "climate-issue-4-answer-2": "Work with developers to harden structures: Require building standards that are stricter than the state’s",
      "climate-issue-4-answer-3": "Work with property owners to harden structures and ensure defensible space around each through incentives or fines",
      "climate-issue-4-answer-4": "Prohibit or restrict new developments in fire-prone areas"
    }
  },
  "homelessness": {
    "homelessness-issue-1": {
      "homelessness-issue-1-answer-1": "Keep as is",
      "homelessness-issue-1-answer-2": "Keep it, but expand support for those experiencing homelessness",
      "homelessness-issue-1-answer-3": "Change the law or change how it’s implemented",
      "homelessness-issue-1-answer-4": "Repeal it"
    },
    "homelessness-issue-2": {
      "homelessness-issue-2-answer-1": "Strongly agree",
      "homelessness-issue-2-answer-2": "Somewhat agree",
      "homelessness-issue-2-answer-3": "Somewhat disagree",
      "homelessness-issue-2-answer-4": "Strongly disagree"
    },
    "homelessness-issue-3": {
      "homelessness-issue-3-answer-1": "Yes, the homelessness crisis makes everyone less safe",
      "homelessness-issue-3-answer-2": "It's debatable"
    },
    "homelessness-issue-4": {
      "homelessness-issue-4-answer-1": "Build more permanent affordable housing",
      "homelessness-issue-4-answer-2": "Build more temporary shelters",
      "homelessness-issue-4-answer-3": "Expand mental health facilities and access",
      "homelessness-issue-4-answer-4": "Create more jobs",
      "homelessness-issue-4-answer-5": "Lower the cap on rent increases in the city’s rent-controlled housing",
      "homelessness-issue-4-answer-6": "All or some combination of the above"
    }
  },
  "economics": {
    "economics-issue-1": {
      "economics-issue-1-answer-1": "Increase equitable investment in traffic calming infrastructure (i.e. left-turn arrows, high visibility crosswalks, curb extensions, traffic circles, etc.)",
      "economics-issue-1-answer-2": "Advocate for speed cameras (would require state legislation)",
      "economics-issue-1-answer-3": "Direct police to write more traffic tickets",
      "economics-issue-1-answer-4": "Expand work on reducing speed limits",
      "economics-issue-1-answer-5": "Create more car-free zones throughout the city"
    },
    "economics-issue-2": {
      "economics-issue-2-answer-1": "Keep them as is",
      "economics-issue-2-answer-2": "Lower them",
      "economics-issue-2-answer-3": "Raise them",
      "economics-issue-2-answer-4": "Eliminate them"
    },
    "economics-issue-3": {
      "economics-issue-3-answer-1": "Lift them now",
      "economics-issue-3-answer-2": "Let them expire",
      "economics-issue-3-answer-3": "Extend them"
    },
    "economics-issue-4": {
      "economics-issue-4-answer-1": "It’s adequate",
      "economics-issue-4-answer-2": "It’s too low",
      "economics-issue-4-answer-3": "At that level, it places too much of a burden on small businesses",
      "economics-issue-4-answer-4": "I don’t support a minimum wage"
    },
    "economics-issue-5": {
      "economics-issue-5-answer-1": "Yes",
      "economics-issue-5-answer-2": "No"
    }
  },
  "policing": {
    "policing-issue-1": {
      "policing-issue-1-answer-1": "Increase sworn officers to the authorized limit",
      "policing-issue-1-answer-2": "Push to authorize even more officers",
      "policing-issue-1-answer-3": "Reduce, or keep it at the current level"
    },
    "policing-issue-2": {
      "policing-issue-2-answer-1": "Stay the same",
      "policing-issue-2-answer-2": "Increase",
      "policing-issue-2-answer-3": "Decrease"
    },
    "policing-issue-3": {
      "policing-issue-3-answer-1": "Expand the number of available Mental Evaluation Units (there are currently only 10-12), which pair a mental health clinician with an armed officer",
      "policing-issue-3-answer-2": "Increase mental health crisis response training for officers",
      "policing-issue-3-answer-3": "Improve training for dispatchers so they can funnel calls to 988, the new mental health crisis line"
    },
    "policing-issue-4": {
      "policing-issue-4-answer-1": "Yes",
      "policing-issue-4-answer-2": "No"
    },
    "policing-issue-5": {
      "policing-issue-5-answer-1": "Broadly aligns with my beliefs",
      "policing-issue-5-answer-2": "I disagree with some of his agenda",
      "policing-issue-5-answer-3": "I disagree with most of his agenda",
      "policing-issue-5-answer-4": "I disagree with most of his agenda and think he should have been recalled from office"
    },
    "policing-issue-6": {
      "policing-issue-6-answer-1": "Increase funding for community-based policing",
      "policing-issue-6-answer-2": "Increase officer training in de-escalation techniques",
      "policing-issue-6-answer-3": "Replace the current police chief"
    }
  }
}